/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItemsLanding_user = {
    readonly isVip: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedBlurbPcs_user">;
    readonly " $refType": "PdpRespSimilarItemsLanding_user";
};
export type PdpRespSimilarItemsLanding_user$data = PdpRespSimilarItemsLanding_user;
export type PdpRespSimilarItemsLanding_user$key = {
    readonly " $data"?: PdpRespSimilarItemsLanding_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemsLanding_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSimilarItemsLanding_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isVip",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbPcs_user",
      "args": null
    }
  ]
};
(node as any).hash = '3c413b6b4c33020a7d55246c82115217';
export default node;
